// extracted by mini-css-extract-plugin
export default {"bgLinear":"Home_bgLinear__oikSR","textLinear":"Home_textLinear__9eWZM","fontText":"Home_fontText__NaJ4v"};